import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, FileText, Clock, Award, ShieldCheck, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-12 overflow-hidden" data-id="element-327">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-60" data-id="element-328"></div>
      <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-energy/5 blur-[120px] rounded-full pointer-events-none" data-id="element-329"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-330">
        {/* Announcement Bar */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="flex items-center justify-center mb-6" data-id="element-331">
          <div className="bg-petroleum/80 backdrop-blur-sm border border-electric/30 rounded-2xl py-3 px-8 md:px-16 flex flex-col items-center gap-1.5 text-xs md:text-sm w-full max-w-2xl" data-id="element-332">
            <span className="inline-flex items-center gap-1.5 bg-electric/15 text-electric font-semibold rounded-full px-2.5 py-0.5" data-id="element-333">
              <Leaf className="w-3.5 h-3.5 fill-electric" data-id="element-334" />
              BIBLIOTECAS DIGITALES™
            </span>
            <span className="text-textsecondary" data-id="element-335">Negocio Fitness IA</span>
          </div>
        </motion.div>

        <div className="max-w-5xl mx-auto text-center" data-id="element-336">
          {/* Title */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="md:text-5xl lg:text-6xl font-extrabold mb-6 text-[33px] leading-tight" data-id="element-337">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric to-energy" data-id="element-338">
              Negocio Fitness IA
            </span>
            <br data-id="element-339" />
            <span className="text-white" data-id="element-340">Crea y Vende Planes de Nutrición</span>
          </motion.h1>

          {/* Mockup + Floating CTA card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.5
        }} className="relative mb-4 pb-16 md:pb-20" data-id="element-341">
            <div className="absolute inset-0 bg-electric/20 blur-[100px] rounded-full" data-id="element-342"></div>

            <img src="https://cdn.magicpatterns.com/uploads/nxgGrs8mRxAmgKgApnE25N/mockup_sf.png" alt="KIT Negocio Fitness IA" className="relative z-10 w-full max-w-[320px] md:max-w-md mx-auto max-h-[46vh] object-contain drop-shadow-2xl hover:scale-105 transition-transform duration-500" data-id="element-343" />

            {/* Floating CTA pill — neon electric, eyebrow inside, arrow on right, sits at the bottom of the mockup */}
            <a href="#pricing" className="absolute left-1/2 -translate-x-1/2 bottom-0 z-20 w-[92%] max-w-md bg-electric hover:bg-electric/90 text-graphite rounded-full pl-6 pr-2 py-2 shadow-2xl shadow-electric/50 glow-electric flex items-center justify-between gap-3 transition-all duration-300 transform hover:-translate-y-0.5 group" data-id="element-344">
              <div className="flex flex-col items-start leading-tight" data-id="element-345">
                <span className="text-[10px] md:text-xs font-semibold uppercase tracking-wider text-graphite/80" data-id="element-346">
                  Acceso Instantáneo
                </span>
                <span className="text-sm md:text-base font-extrabold uppercase tracking-wide" data-id="element-347">
                  QUIERO EL KIT AHORA
                </span>
              </div>
              <span className="flex-shrink-0 w-11 h-11 md:w-12 md:h-12 rounded-full bg-graphite text-electric flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-348">
                <ArrowRight className="w-5 h-5 md:w-6 md:h-6" strokeWidth={3} data-id="element-349" />
              </span>
            </a>
          </motion.div>

          {/* Subhead */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-lg md:text-xl text-textsecondary mb-5 max-w-2xl mx-auto" data-id="element-350">
            El sistema N°1 para profesionales del fitness que quieren crear y
            vender planes de nutrición online con IA.
          </motion.p>

          {/* Trust Badges */}
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-6 text-sm md:text-base font-medium" data-id="element-351">
            <div className="flex items-center gap-2" data-id="element-352">
              <FileText className="w-5 h-5 text-electric" data-id="element-353" />
              <span className="text-[10px]" data-id="element-354">100% PDF</span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-textsecondary/50" data-id="element-355"></div>
            <div className="flex items-center gap-2" data-id="element-356">
              <Clock className="w-5 h-5 text-electric" data-id="element-357" />
              <span className="text-[10px]" data-id="element-358">Acceso en 5 min</span>
            </div>
            <div className="hidden md:block w-1 h-1 rounded-full bg-textsecondary/50" data-id="element-359"></div>
            <div className="flex items-center gap-2" data-id="element-360">
              <Award className="w-5 h-5 text-electric" data-id="element-361" />
              <span className="text-[10px]" data-id="element-362">De 0 a Negocio Digital</span>
            </div>
          </div>

          {/* Trust micro-badges (CTA moved above the mockup) */}
          <div className="flex flex-col items-center gap-4" data-id="element-363">
            <div className="flex flex-wrap items-center justify-center gap-4 text-xs md:text-sm text-textsecondary" data-id="element-364">
              <div className="flex items-center gap-1" data-id="element-365">
                <ShieldCheck className="w-4 h-4" data-id="element-366" /> Garantía 7 días
              </div>
              <div className="flex items-center gap-1" data-id="element-367">
                <Lock className="w-4 h-4" data-id="element-368" /> Pago seguro
              </div>
              <div className="flex items-center gap-1" data-id="element-369">
                <CreditCard className="w-4 h-4" data-id="element-370" /> Mercado Pago
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}